<template>
  <div :style="{ display: display ? 'block' : 'none' }" class="text-center loader-big">
    <FontAwesomeIcon icon="spinner" spin />
  </div>
</template>

<script>
export default {

  name: 'Loader',

  props: {
    display: Boolean
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/Loader.vue